import request from "../utils/request";

export function exportProcessReport(keyword, createDate) {
    return request({
        url: '/api/order/process/report/export',
        method: 'post',
        data: {keyword, createDate},
        responseType: 'blob',
    })
}
